import type { ConsentResponse } from '../api/client';

/**
 * GET /v1/consent の1行が「同意済み」か。
 * OpenAPI 上 status は granted | revoked のみ。主判定は status === 'granted'、
 * Field 説明どおり granted_at 非null も併用可。
 */
export function isConsentRowGranted(c: ConsentResponse): boolean {
  return c.status === 'granted' || c.granted_at != null;
}

/** 未処理の同意が残っているか（一覧が空ならブロックしない） */
export function hasPendingConsents(rows: ConsentResponse[]): boolean {
  return rows.length > 0 && rows.some((c) => !isConsentRowGranted(c));
}
